<template>
    <FormCardsContainer></FormCardsContainer>
</template>

<script>
import FormCardsContainer from '../components/FormCardsContainer'
export default {
    name:'ConsultarAgendamento',
    components: {FormCardsContainer}
}
</script>

<style scoped>

</style>